import { Routes } from '@angular/router';
import { HomeComponentBC } from './blend-calculator/components/home/home.component';
import { HomeComponentFO } from './formula-optimizer/components/home/home.component';
import { calGuard } from '@cvx/cal-angular';
import { HomeComponent } from './home/home.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { securityGroupGuard } from './shared/guards/security-group.guard';

/**
 * Route map for the application.
 * Protected views use securityGroupGuard to run CAL authentication before
 * Azure AD group membership authorization.
 */
export const routes: Routes = [
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [
      calGuard
    ]
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [
      securityGroupGuard
    ]
  },
  {
    path: 'formula-optimization',
    component: HomeComponentFO,
    canActivate: [
      securityGroupGuard
    ]
  },
  {
    path: 'blend-calculator',
    component: HomeComponentBC,
    canActivate: [
      securityGroupGuard
    ]
  },
  {
    // Shared favorite deep-link (opened in a new tab). Same auth/authorization as every other view.
    path: 'shareddata/:filename',
    component: HomeComponentBC,
    canActivate: [
      securityGroupGuard
    ]
  }
];
